import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const pituitaryGlandDisorder: AnswerPathTreeNode = {
  path: 'pituitaryGlandDisorder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredPituitaryGlandDisorderDetails }],
};
